var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"has-inset-shadow-top",attrs:{"id":"u-client-footer"}},[_c('powered-by-upmind',{staticClass:"is-size-7 has-text-centered"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }